import {
  Brain,
  Car,
  Dumbbell,
  Gamepad2,
  GraduationCap,
  HandHeart,
  Heart,
  Megaphone,
  Mountain,
  Laptop,
  type LucideIcon,
  Music,
  PartyPopper,
  PawPrint,
  Plane,
  Popcorn,
  Salad,
  Shirt,
  Smile,
  Sparkles,
  Sunrise,
  Trophy,
  Users,
  Utensils,
  Wallet,
} from 'lucide-react'

type Tone = 'pink' | 'green' | 'blue' | 'purple' | 'orange'

/** The tile colors for a theme's icon, light-on-tint as in the setup designs */
export const TONES: Record<Tone, { tile: string; icon: string; chip: string }> = {
  pink: { tile: 'bg-[#FDE7EE]', icon: 'text-[#E11D48]', chip: 'border-[#FBCFDC] bg-[#FFF5F8]' },
  green: { tile: 'bg-[#DCFCE7]', icon: 'text-[#15803D]', chip: 'border-[#BBF7D0] bg-[#F3FDF6]' },
  blue: { tile: 'bg-[#E0F0FF]', icon: 'text-[#1D72D8]', chip: 'border-[#C7E2FB] bg-[#F3F9FF]' },
  purple: { tile: 'bg-[#EEE7FE]', icon: 'text-[#7C3AED]', chip: 'border-[#DDD0FC] bg-[#F8F5FF]' },
  orange: { tile: 'bg-[#FFEEDB]', icon: 'text-[#EA7A0C]', chip: 'border-[#FCDDB8] bg-[#FFF8F0]' },
}

const BY_CATEGORY: Record<string, { icon: LucideIcon; tone: Tone }> = {
  sport_competition: { icon: Trophy, tone: 'pink' },
  training_fitness: { icon: Dumbbell, tone: 'green' },
  lifestyle: { icon: Sunrise, tone: 'blue' },
  recovery_wellness: { icon: Heart, tone: 'purple' },
  humor_comedy: { icon: Smile, tone: 'orange' },
  music_dance: { icon: Music, tone: 'pink' },
  gaming: { icon: Gamepad2, tone: 'purple' },
  food_dining: { icon: Utensils, tone: 'orange' },
  nutrition: { icon: Salad, tone: 'green' },
  travel: { icon: Plane, tone: 'blue' },
  family_relationships: { icon: Users, tone: 'green' },
  fashion_style: { icon: Shirt, tone: 'pink' },
  beauty_grooming: { icon: Sparkles, tone: 'pink' },
  motivation_mindset: { icon: Brain, tone: 'green' },
  education_career: { icon: GraduationCap, tone: 'blue' },
  entertainment_pop_culture: { icon: Popcorn, tone: 'orange' },
  money_finance: { icon: Wallet, tone: 'green' },
  tech_gadgets: { icon: Laptop, tone: 'blue' },
  outdoors_adventure: { icon: Mountain, tone: 'green' },
  social_events: { icon: PartyPopper, tone: 'pink' },
  sports_fandom_commentary: { icon: Megaphone, tone: 'orange' },
  automotive: { icon: Car, tone: 'blue' },
  pets: { icon: PawPrint, tone: 'orange' },
  community_faith_causes: { icon: HandHeart, tone: 'purple' },
}

/** The icon and colors for a content theme, from the category it belongs to */
export const themeStyle = (category?: string | null) => {
  const s = (category && BY_CATEGORY[category]) || { icon: Sparkles, tone: 'blue' as Tone }
  return { Icon: s.icon, ...TONES[s.tone] }
}
